import { AsyncStateNotification } from '@ui/notifications';
import { Button } from 'antd';
import { createAsyncSelectors } from '@lib/selectors';
import React from 'react';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { useAction, useCurrentUser, useFeatureFlag } from '@hooks';
export const exportStartSelectors = createAsyncSelectors((state) => state.core.dataSecurity.apiVolume.export.post);
export const ApiVolumeTableExportButton = ({ request }) => {
    const startExport = useAction(coreActions.requestPostCoreDataSecurityApiVolumeTableExport);
    const { isReadOnly } = useCurrentUser();
    const isExportEnabled = useFeatureFlag(FeatureFlag.Export);
    if (isReadOnly) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { disabled: !isExportEnabled, id: 'api-volume-table-export-button', onClick: () => startExport(request) }, COPY_SPECIFIC.EXPORT),
        React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.CONTACT_SUPPORT, failed: {
                description: COPY_GENERIC.TOO_MANY_EXPORTS,
                options: { message: COPY_GENERIC.COULD_NOT_START_EXPORT }
            }, received: {
                description: COPY_GENERIC.WHEN_EXPORT_COMPLETES,
                options: { message: COPY_GENERIC.EXPORT_STARTED }
            }, resetRawAction: coreActions.resetPostCoreDataSecurityApiVolumeTableExport, stateSelector: exportStartSelectors.state })));
};
